import ReactTooltip from 'react-tooltip';
import Text from '../../../atoms/Text';
import Image from '../../../atoms/Image';
import question_in_circle from '../../../assets/images/question_in_circle.svg';

const Deadline = ({ deadline, onSetDeadline }: any) => {
  const onBlur = (value: string | number, on_change: Function) => {
    const val = Number(String(value).replace(',', '.'));
    if (val) {
      on_change(val);
    } else {
      on_change(0);
    }
  };

  return (
    <div className='row deadline_line'>
      <div className='row deadline_line__title'>
        <Text size={12}>Order deadline (days)</Text>
        <div
          className='deadline_line__title__info'
          data-for='deadline-tooltip'
          data-tip='Days before the order<br />is automatically canceled'
        >
          <Image src={question_in_circle} size='s' />
        </div>
      </div>
      <input
        className='input text--12'
        type="number"
        value={deadline}
        onChange={(e) => onSetDeadline(e.target.value)}
        onBlur={() => onBlur(deadline, onSetDeadline)}
      />
      <ReactTooltip
        id='deadline-tooltip'
        type='light'
        place='bottom'
        effect='solid'
        className='text_tooltip'
        multiline={true}
      />
    </div>
  );
};

export default Deadline;
